import { Navigate } from 'react-router';
import { useSession } from '../state/session.js';

export function HomePage() {
  const { projects } = useSession();
  // MySpace is the sign-in home; explicit project and conversation links keep their route.
  const first = projects.find((p) => p.kind === 'personal') ?? projects[0];
  return <Navigate to={first ? `/p/${first.id}` : '/projects/new'} replace />;
}
